module.exports = __webpack_public_path__ + "static/media/help-icon.d55cb11a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help-icon.svg
// module id = 465
// module chunks = 0